var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute inset-0 pointer-events-none",class:`${_vm.directionStyle}`,style:({
    [_vm.isHorizontal ? 'width' : 'height']: _vm.size + 'px',
    background: `linear-gradient(to ${_vm.direction}, ${_vm.startColor} 0%, ${_vm.endColor} 65%`
})})
}
var staticRenderFns = []

export { render, staticRenderFns }